const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  companyId: state => state.user.companyId,
  groupId: state => state.user.groupId,
  companyType: state => state.user.companyType,
  msgCount: state => state.user.msgCount,
  mapStatus: state => state.user.mapStatus
}
export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js